import React, { PureComponent } from 'react';
import Dropdown from '../standardAttributes/Dropdown';

export default class AboveAdditionalToolSupport extends PureComponent {
  render() {
    const {
      appApi,
      attributeName,
      configuration,
      selectedModel,
      models,
    } = this.props;
    const selectedModelAttr =
      models[selectedModel] && models[selectedModel].attribute;
    const checkForValues =
      selectedModelAttr &&
      selectedModelAttr.indexOf('aboveOverheadToolSupport') >= 0;
    let listOptions;

    listOptions = checkForValues
      ? appApi.config
          .getAttributeAvailableValues(
            attributeName,
            configuration,
            models[selectedModel].value
          )
          .map(option =>
            Object.assign(option, {
              number: models[selectedModel].children.filter(
                id => models[id].value === option.value
              ).length,
            })
          )
      : [];
    return <Dropdown {...this.props} options={listOptions} />;
  }
}



// WEBPACK FOOTER //
// ./src/components/Attributes/nonStandardAttributes/AboveAdditionalToolSupport.js